import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import PrismicReact from 'prismic-reactjs'
import PropTypes from 'prop-types'
import Slider from "react-slick"

const propTypes = {
  slice: PropTypes.object,
  linkResolver: PropTypes.func
}

class OtherSection extends Component {
  render() {
    let { 
      slice,
      linkResolver
    } = this.props

    let settings = {
      slidesToShow: slice.items.length,
      slidesToScroll: 1,
      infinite: true,
      dots: false,
      arrows: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            dots: true,
            infinite: true,
            speed: 500,
            slidesToShow: 2,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 768,
          settings: {
            dots: true,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
          }
        },
      ]
    }

    return (
      <section className="section-other">
        {PrismicReact.RichText.render(slice.primary.section_title)}
        <Slider {...settings}>
          {
            slice.items.map((slide, index) => {
              let s = slide.product_page_link.data
              return (
                <div key={index} className="product-slide">
                  <div className="product-slide__image" style={{ backgroundImage: `url(${s.product_banner_image.url})`}}></div>
                  <div className="product-slide__title">
                    <h3>{PrismicReact.RichText.asText(s.product_title)}</h3>
                  </div>
                  <Link to={PrismicReact.Link.url(slide.product_page_link, linkResolver)} className="anchor-fill"></Link>
                </div>
              )
            })
          }
        </Slider>
      </section>
    )
  }
}

OtherSection.propTypes = propTypes

export default OtherSection


// WEBPACK FOOTER //
// ./src/components/ProductPage/OtherSection.js